import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

export interface ILocationGroupDetail {
  id: number
  name: string
  type: string
  brandId: number
  email: string
}

export interface ILocationGroupDetailsMap {
  [locationGroupId: number]: ILocationGroupDetail
}

const gqlQuery = gql`
  query ListLocationGroupDetails {
    locationGroups(
      condition: { endDate: "9999-12-31 23:59:59.000000 +00:00" }
    ) {
      nodes {
        id
        name
        type
        brandId
        email
      }
    }
  }
`

function useListLocationGroupDetails() {
  const { data, loading } = useQuery(gqlQuery)

  return {
    isLoading: loading,
    data: useMemo(() => {
      if (!data?.locationGroups?.nodes) {
        return null
      }

      const locationGroupsMap: ILocationGroupDetailsMap = {}

      data.locationGroups.nodes.forEach((node: any) => {
        locationGroupsMap[node.id] = {
          id: node.id,
          name: node.name,
          type: node.type,
          brandId: node.brandId,
          email: node.email,
        }
      })

      return locationGroupsMap
    }, [data]),
  }
}

export default useListLocationGroupDetails
